import { render, staticRenderFns } from "./AwardIcon.vue?vue&type=template&id=386a8c86&"
import script from "./AwardIcon.vue?vue&type=script&lang=js&"
export * from "./AwardIcon.vue?vue&type=script&lang=js&"
import style0 from "./AwardIcon.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports